import React from 'react';
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import styled from 'styled-components';

const DownloadButton = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
`;

const DownloadCsvText = styled.span`
  font-size: 12px;
  color: #fe2f67;
  font-weight: 700;
  margin-left: 0.25rem;
`;

interface DownloadCSVButtonProps {
  data: any[];
  headers: string[];
  filename?: string;
  label?: string;
}

const DownloadCSVButton: React.FC<DownloadCSVButtonProps> = ({ data, headers, filename = 'data.csv', label = 'Download - CSV.format' }) => {
  const handleDownloadCSV = () => {
    if (!data || data.length === 0) return;
    const csvHeader = headers.join(',') + '\n';
    const csvRows = data
      .map((row) =>
        headers.map((header) => `"${row[header] ?? ''}"`).join(',')
      )
      .join('\n');
    const csvContent = csvHeader + csvRows;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <DownloadButton onClick={handleDownloadCSV}>
      <DownloadForOfflineIcon sx={{ color: "#fe2f67", fontSize: '20px' }}/>
      <DownloadCsvText>{label}</DownloadCsvText>
    </DownloadButton>
  );
};

export default DownloadCSVButton; 